import { useNavigate } from "react-router-dom";
import MainHeaderStore from "../../../../stores/MainHeaderStore";
import { Address } from "@ton/core";

interface Props {
  headerStore: MainHeaderStore;
  address: string;
}

const useMainHeaderSearchItem = ({ headerStore, address }: Props) => {
  const navigate = useNavigate();

  const onClick = () => {
    navigate("/collection/" + Address.parse(address).toString());
    headerStore.setSearchString("");
    headerStore.setIsSearchMobOpen(false);
  };
  return { onClick };
};

export default useMainHeaderSearchItem;
